import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Account       from './../../components/common/profile/Account';
import Grid          from '@material-ui/core/Grid';
import Helmet        from 'react-helmet';
import Information   from './../../components/common/profile/Information';
import OAuth         from './../../components/common/profile/OAuth/OAuth';
import Security      from './../../components/common/profile/Security';
import PageContainer from '../../components/layout/Container/PageContainer';
import OtpTable      from '../../components/common/profile/OTP/table/OtpTable';
import { Title }     from '../../components/core/typography/Title';
import Button        from '../../components/core/input/Button';
import DeleteAccountDialog from '../../components/common/profile/DeleteAccountDialog';
import Typography    from '@material-ui/core/Typography';

const Profile = () => {
	const { t } = useTranslation();
	const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

	return (
		<PageContainer>
			<Helmet>
				<title>{t('navigation_settings')}</title>
			</Helmet>
			<Grid container spacing={3}>
				{ /* TBD add helmet */}
				<Grid item xs={12}>
					<Account/>
				</Grid>

				<Grid item xs={12}>
					<Information/>
				</Grid>

				<Grid item xs={12}>
					<Security/>
				</Grid>
				<Grid item xs={12}>
					<OAuth/>
				</Grid>
				<Grid item xs={12}>
					<OtpTable/>
				</Grid>
				<Grid item xs={12}>
					<Grid container spacing={2} direction="column">
						<Grid item>
							<Title>Delete Account</Title>
						</Grid>
						<Grid item>
							<Typography variant="body2" style={{ marginBottom: '16px' }}>
								⚠️ Account deletion requests take 30 days to process. During this period, you can contact support to cancel the deletion request. After 30 days, your account will be irrevocably deleted and cannot be recovered.
							</Typography>
						</Grid>
						<Grid item>
							<Button
								variant="outlined"
								color="secondary"
								onClick={() => setDeleteDialogOpen(true)}
							>
								Delete Account
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<DeleteAccountDialog
				open={deleteDialogOpen}
				setOpen={setDeleteDialogOpen}
			/>
		</PageContainer>
	);
};

export default Profile;
